// Client wrappers for the spectator endpoints.

const TRIP_DEFAULT = 'juneau-2026';

async function postJson(url, body) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  });
  let data;
  try { data = await res.json(); } catch { data = {}; }
  if (!res.ok) {
    const err = new Error(data.message || `${url} → ${res.status}`);
    err.status = res.status;
    err.detail = data;
    throw err;
  }
  return data;
}

async function getJson(url) {
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) {
    const err = new Error(`${url} → ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

export async function fetchSpectatorFeed({ tripId = TRIP_DEFAULT, limit = 20 } = {}) {
  return getJson(`/api/spectator/feed?trip_id=${tripId}&limit=${limit}`);
}

export async function submitReaction({ tripId = TRIP_DEFAULT, submissionId, reaction }) {
  return postJson('/api/spectator/reaction', {
    trip_id: tripId,
    submission_id: submissionId,
    reaction,
  });
}

export async function submitComment({ tripId = TRIP_DEFAULT, submissionId, body }) {
  return postJson('/api/spectator/comment', {
    trip_id: tripId,
    submission_id: submissionId,
    body,
  });
}

export async function overrideVerdict({ tripId = TRIP_DEFAULT, submissionId, newPoints, reason }) {
  return postJson('/api/spectator/verdict-override', {
    trip_id: tripId,
    submission_id: submissionId,
    new_points: newPoints,
    reason,
  });
}
